export default __webpack_public_path__ + "static/media/landin-blockimg8.374a872f.png";